import {computed} from "vue";

export function useSensorCompute(context){
    return  function (id, type){
        return computed(() => {
            if (!context.value?.[id]) return '--'
            if (type == 0) {
                //温度
                return context.value?.[id]?.i + (context.value?.[id]?.status == 1 ? '℃' : '')
            }
            else if (type == 1){
                //湿度
                return context.value?.[id]?.u + (context.value?.[id]?.status == 1 ? '%RH' : '')
            }
            else if (type == 2){
                //烟雾
                return (context.value?.[id]?.p === '0' ? '正常' : context.value?.[id]?.p) + (context.value?.[id]?.status == 1 && context.value?.[id]?.p !== '0' ? 'ppm' : '')
            }
            else if (type == 3){
                //水浸
                return context.value?.[id]?.status == 1 ? (context.value?.[id]?.q == 0 ? '正常' : '有水')  : context.value?.[id]?.q
            }
            else {
                return '';
            }
        })
    }

}